import { Separator } from '@ais-ui/ui-core';
import { NotificationsForm } from './NotificationsForm';

export function SettingsNotificationsPage() {
  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-lg font-medium">Notifications</h3>
        <p className="text-sm text-muted-foreground">
          Configure how you receive notifications.
        </p>
      </div>
      <Separator className="w-full" />
      <NotificationsForm />
    </div>
  );
}
